import '~/sass/pages/tech-hybrid-2.scss';
import Vue from 'vue';
import Rx from 'rxjs/Rx';
import VueRx from 'vue-rx';

// import AArticle2pc from './canvas/AArticle2_pc.vue';
// import AArticle2_mb from './canvas/AArticle2_mb.vue'

Vue.use(VueRx, Rx);

export default () => {
  const article2Vm = new Vue({
    el: '#article2',
    props: [],

    data() {
      return {
        clientWidth: document.body.clientWidth,
        currentIndex: 1,
        showContent: false,
        otherHover: false,
        options: {
          offset: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          },
          threshold: 0.5,
        },
        once: false,
        playAnimate: 0,
      };
    },

    computed: {
      isMobile() {
        const { clientWidth } = this;
        return clientWidth < 960;
      },
    },
    mounted() {
      this.showContent = true;
      this.$subscribeTo(
        Rx.Observable.fromEvent(window, 'resize')
          .debounceTime(100)
          .distinctUntilChanged(),
        this.onResize,
      );
      // this.AArticle2pc();
    },
    beforeDestroy() {
      this.showContent = false;
    },
    methods: {
      onResize() {
        this.clientWidth = document.body.clientWidth;
      },
      onAnimateLoaded() {
        this.playAnimate += 1;
      },
      close() {
        this.gaev('btn_article_2_close');
        this.$emit('close');
      },
      onDotClicked(value) {
        this.gaev(`btn_article_2_HV${value}`);
        this.currentIndex = value;
      },
      onLeftArrowClicked() {
        let index = this.currentIndex;
        index -= 1;
        if (index > 0) {
          this.gaev(`btn_article_2_HV${index}`);
          this.currentIndex = index;
        }
      },
      onRightArrowClicked() {
        let index = this.currentIndex;
        index += 1;
        if (index < 8) {
          this.gaev(`btn_article_2_HV${index}`);
          this.currentIndex = index;
        }
      },
      mouseOver(value) {
        this.otherHover = (value !== this.currentIndex);
      },
      mouseLeave() {
        this.otherHover = false;
      },
      onMoreClick() {
        this.gaev('btn_article_2_hybrid');
        window.open('/tech_hybrid.html?debug=medialand#/action');
      },
    },
  });
  return article2Vm;
};
